export const endpoints = {
  companies: '/companies',
  company: '/companies/{id}',
  companyStats: '/companies/{id}/stats',
  companyInbound: '/companies/{id}/inbound',
  companyNotes: '/companies/{id}/notes',
  companyNote: '/companies/{companyId}/notes/{id}',
  resetCompany: '/companies/{id}/reset',
  companyProfile: '/companies/{id}/profile',
  companyProfileLookup: '/companies/{id}/profile/lookup',
  industries: '/companies/industries',
} as const;
